import { ContactTerminal } from './ContactTerminal';
import { SystemFrame } from '../primitives';

export const CommunicationsScreen = () => {
  return (
    <SystemFrame id="communications-terminal" className="min-h-[calc(100vh-6.5rem)] pb-20 pt-24">
      <ContactTerminal />
    </SystemFrame>
  );
};
